import React, { Component } from 'react';
import * as config from '../../config'


export default class AdaptiveBlock extends Component {

    constructor (props) {
        super(props)
        this.tagName = this.props.tagname
        this.mobileClassName = 'mobile'
        this.desktopClassName = 'desktop'
        this.state = {
            mobile: this.initMobileDetermination(this.props.mobile),
        }
    }

    render() {
        const TagName = this.tagName
        return (
            <TagName {...this.props} className={this.getClassName()}>
                {this.props.children}
            </TagName>
        )
    }

    getClassName = () => {
        const baseClasses = this.props.className || ""
        if(this.state.mobile) return baseClasses + ' ' + this.mobileClassName
        else return baseClasses + ' ' + this.desktopClassName
    }

    componentDidMount() {
        if (this.useWatchdog) {
            this.runWatchdog()
        }
    }

    componentWillUnmount() {
        if (this.useWatchdog) this.stopWatchdog()
    }

    initMobileDetermination = (byProps) => {
        if (!['true', 'false', true, false].includes(byProps)) {
            this.useWatchdog = true
            return this.isScreenMobile()
        }
        return ['true', true].includes(byProps) ? true : false
    }

    isScreenMobile = () => window.innerWidth < config.MOBILE_WIDTH


    runWatchdog = () => {
        this.watcherID = setInterval(
            () => this.checkWindowWidth(),
            500
        );
    }

    stopWatchdog = () => clearInterval(this.watcherID);

    checkWindowWidth = () => {
        var isMobile = this.isScreenMobile()
        if (isMobile !== this.state.mobile){
            this.setState({mobile: isMobile})
        }
    }
}
